import React, { useEffect, useMemo, useState } from "react";
import ActionableTable from "../actionables/ActionableTable";
import useAssignedOrders from "modules/customerlist/store";
import ShowCustomer from "../actionables/ShowCustomer";
import ProfilePlaceHolder from "./ProfilePlaceHolder";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function CustomersList({ assignedOrder }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [docData, setDocData] = useState(null);
  const [clear, setClear] = useState(0);
  const {
    customersData,
    isLoading,
    fetchAssignedOrderData,
    paginationData,
    fetchAssignedOrderFilterData,
  } = useAssignedOrders();
  const [showCustomerInFull, setShowCustomerInFull] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNumber");
  const [queryParams, setQueryParams] = useState("");
  const [activeCaseId, setActiveCaseId] = useState();

  useEffect(() => {
    setDocData(null);
  }, []);
  const urlData = useMemo(() => {
    const query = window.location.href;
    return query.split("?")[1];
  }, [location]);

  const url = useMemo(() => {
    return urlData;
  }, [urlData]);

  const params = new URLSearchParams(url);
  params.delete("pageNumber");
  const updatedQueryString = params.toString();

  const newPage = (n) => {
    setPageNumber(n);
  };

  useEffect(() => {
    setPageNumber(pageData);
  }, []);

  useEffect(() => {
    if (clear) {
      navigate("/dashboard/home/assigned-orders?pageNumber=1");
      setClear(0);
      return;
    }
    if (queryParams || url?.length > 15) {
      if (queryParams) {
        navigate(
          `/dashboard/home/assigned-orders?pageNumber=${pageNumber}${queryParams}`
        );
      } else {
        navigate(
          `/dashboard/home/assigned-orders?pageNumber=${pageNumber}&${updatedQueryString}`
        );
      }
    } else {
      navigate(`/dashboard/home/assigned-orders?pageNumber=${pageNumber}`);
    }
  }, [pageNumber, queryParams, updatedQueryString]);

  useEffect(() => {
    if (url?.length > 15) {
      fetchAssignedOrderFilterData(url);
      navigate(`/dashboard/home/assigned-orders?${url}`);
    } else if (url?.length < 15) {
      fetchAssignedOrderData(pageData);
      navigate(`/dashboard/home/assigned-orders?pageNumber=${pageData}`);
    }
  }, [url, pageData]);

  const data = customersData
    ?.slice()
    ?.reverse()
    ?.map((customer) => {
      let orderCount = customer.count;
      let repeatOrderTag = orderCount <= 1 ? "NEW" : `RO ${orderCount}`;
      return {
        alternate_email: "",
        order: customer?.order,
        status: customer?.status,
        case_id: customer?.case_id,
        alternate_phone_number: "",
        order_count: customer?.count,
        bulk: customer?.is_bulk_order,
        created_at: customer?.created_at,
        updated_at: customer?.updated_at,
        order_type: customer?.order_type,
        single: customer?.is_single_order,
        email: customer?.case?.user?.email,
        tracking_id: customer?.tracking_id,
        tracking_url: customer?.tracking_url,
        order_id: customer?.order_display_id,
        gender: customer?.case?.user?.gender,
        order_name: customer?.order_meta?.name,
        delivery_date: customer?.delivery_date,
        last_name: customer?.case.user?.last_name,
        reschedule_count: customer?.reschedule_count,
        first_name: customer?.case?.user?.first_name,
        phone_number: customer?.case?.user?.phone_number,
        booking_reference_id: customer?.booking_reference_id,
        tags: [customer?.order_type, customer?.status, repeatOrderTag],
      };
    });

  return (
    data && (
      <div style={{ height: "85vh", top: 20 }}>
        <div className="d-flex">
          <div
            style={{
              opacity: showCustomerInFull ? 0 : 1,
              width: showCustomerInFull ? "0" : "33%",
              transition: "width 0.3s ease, opacity 0.3s ease",
              overflow: "hidden",
            }}
          >
            {
              <ActionableTable
                newPage={newPage}
                details={"details"}
                setClear={setClear}
                setState={setDocData}
                setDocData={setDocData}
                fieldOneName={"Doctor Name"}
                setPageNumber={setPageNumber}
                data={data.slice().reverse()}
                assignedOrder={assignedOrder}
                paginationData={paginationData}
                setQueryParams={setQueryParams}
                setActiveCaseId={setActiveCaseId}
              />
            }
          </div>
          <div
            style={{
              height: "85vh",
              width: showCustomerInFull ? "100%" : "67%",
              transition: "width 0.3s ease",
              overflow: "auto",
            }}
            className="flex-fill ms-3 mt-n3 p-0 scrollable-container"
          >
            {isLoading ? (
              <ProfilePlaceHolder />
            ) : docData || data[0] ? (
              <div>
                  <ShowCustomer
                    caseId={activeCaseId || data[data?.length - 1].case_id}
                    setShowCustomerInFull={setShowCustomerInFull}
                    showCustomerInFull={showCustomerInFull}
                  />
              </div>
            ) : (
              <ProfilePlaceHolder />
            )}
          </div>
        </div>
      </div>
    )
  );
}

export default CustomersList;
